import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';
import { translate } from 'javascripts/translations/i18n';

// #region icons and styled-components
const FooterContainer = styled.div`
  width: 100%;
  background: var(--cc_color_background_2);
  position: absolute;
  left: 0;
  bottom: 0;
  padding: var(--cc_size_spacing_m);
  display: flex;
  gap: var(--cc_size_spacing_m);
  justify-content: flex-end;
  align-items: center;
  border-radius: 0 0 var(--cc_size_border_radius_l)
    var(--cc_size_border_radius_l);
  z-index: 1000;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--cc_size_spacing_m);
  width: 100%;
`;
// #endregion

const PickerFooter = ({
  getAllSelected,
  clearSelection,
  selectionCount,
  onSelection = () => {},
  onCancel = () => {},
}) => {
  const handleSelection = () => {
    const assets = getAllSelected();
    onSelection(assets);
  };

  return (
    <FooterContainer>
      <ButtonContainer>
        <Button onClick={clearSelection} disabled={selectionCount === 0}>
          {translate('common.clear')}
        </Button>
        <div style={{ flexGrow: 1 }} />
        <Button onClick={onCancel}>{translate('common.cancel')}</Button>
        <Button
          color="primary"
          onClick={handleSelection}
          disabled={selectionCount === 0}
        >
          {selectionCount === 1
            ? translate('projectPage.assetPicker.addPhoto')
            : translate('projectPage.assetPicker.addPhotos')}
        </Button>
      </ButtonContainer>
    </FooterContainer>
  );
};

PickerFooter.propTypes = {
  getAllSelected: PropTypes.func,
  clearSelection: PropTypes.func,
  onSelection: PropTypes.func,
  onCancel: PropTypes.func,
  selectionCount: PropTypes.number,
};

export default PickerFooter;
